import DataGridRowWrapper from '../DataGridRowWrapper';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

const DataGridHeader: FunctionComponent<Props> = ({ children, ref, testId = TEST_ID }) => (
    <DataGridRowWrapper ref={ref} testId={testId}>
        {children}
    </DataGridRowWrapper>
);

export default DataGridHeader;
